import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { StarRow } from "@/components/StarRow";
import { api, errorMessage } from "@/lib/api";

export function AppRatingForm({ onDone }) {
  const [rating, setRating] = useState(0);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try { await api.post("/app-reviews", { rating, text }); toast.success("Thanks for rating VacaVibe!"); onDone(true); }
    catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="app-rating-form" className="space-y-4">
      <StarRow value={rating} size="h-8 w-8" onPick={setRating} tid="app-rating-star" />
      <textarea data-testid="app-rating-text" value={text} onChange={(e) => setText(e.target.value)} maxLength={1000} rows={3}
        placeholder="Tell other travelers what you think (optional)"
        className="w-full bg-[#0B0F19] border border-[#26334D] rounded-xl px-3 py-2 text-sm outline-none focus:border-[#FFB800]" />
      <Button data-testid="app-rating-submit" disabled={!rating || busy} onClick={submit} className="w-full rounded-xl bg-[#FF3B6B] hover:bg-[#E0335D] text-white font-semibold">Submit rating</Button>
    </div>
  );
}
